<div (click)="onCardClick()" class="home-card-container h-30 px-4 py-3 rounded-lg border-[0.5px]" [ngClass]="customClass ? customClass : '' ">
  <div class="flex justify-center items-center border-r-2 border-gray-250 pr-3 xxl:pr-5">
    <ng-content select="[cardImage]"></ng-content>
  </div>

  <div class="flex flex-col justify-center gap-1 pl-3 xxl:pl-5">
    <ng-content select="[cardInfo]"></ng-content>
  </div>
</div>
